import request from '@/utils/request';

const appName = "huanxinxiang-yunxian";
// 单笔支付
export const alipayNoSignSMSPay = ( data) => request({
  url: '/huanxinxiang-service/v1/alipay-no-sign-sms-pay/',
  method: 'post',
  headers: {
    "App-Name": appName,
  },
  data,
});

// 获取短信
export const code = (data) => request({
  url: '/huanxinxiang-service/v1/code/',
  method: 'post',
  headers: {
    "App-Name": appName,
  },
  data,
});
